import React, { Fragment, useState } from 'react'
import { MenuScreen } from '../UI/MenuScreen'

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import { Player } from '@lottiefiles/react-lottie-player';

import Button from '@mui/material/Button';
import { useForm } from '../../hooks/useForm';
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification } from "firebase/auth";
import { app,db } from "../../firebaseConfig/firebaseConfig";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import { useHistory } from "react-router-dom";

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { getFirestore, collection, getDocs, setDoc, addDoc, doc } from 'firebase/firestore/lite';




export const RegisterScreen = () => {

    const history = useHistory();

    const [open, setOpen] = useState(false);


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };


    const goToLogin = () => {

        history.push("/auth/login");
    }


    const [formValues, handleInputChange] = useForm({
        email: '',
        password: '',
        name: '',
        wallet: ''
    });

    const { email, password, name, wallet } = formValues;

    const createUser = async() => {
        const citiesCol = collection(db, 'cities');
        const citySnapshot = await getDocs(citiesCol);
        const cityList = citySnapshot.docs.map(doc => doc.data());
        return cityList;
    }


    const handleSubmit = () => {
        //e.preventDefault();
        console.log('form values', email, password, name);
        if (email != null && password != null && name != null && wallet !=null) {
            const auth = getAuth();
            createUserWithEmailAndPassword(auth, email, password)
                .then((userCredential) => {
                    // Signed in
                    const user = userCredential.user;
                    console.log(user);
                    sendEmailVerification(user.auth.currentUser)
                        .then(async() => {
                            // Email verification sent!
                            console.log("correo enviado con exito");
                            const data = {
                                email: email,
                                name: name,
                                wallet: wallet
                            }
                            const res = await setDoc(doc(db, "users", user.uid), data);
                    
                            setOpen(true);

                            setTimeout(() => {
                                history.push("/auth/login");
                            }, 4000);
                            // ...
                        });
                    // ...
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    // ..
                });

        } else {
            return;
        }
    }


    const action = (
        <React.Fragment>
            <Button color="primary" size="small" onClick={handleClose}>

            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );


    return (
        <div>

            <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleClose}
                message="Hemos enviado un correo para confirmar tu cuenta por favor revisa tu email"
                action={action}
            />

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
                onClick={handleClose}
            >
                <CircularProgress color="primary" />
            </Backdrop>

            <MenuScreen />
            <div className="login__div">

                <div className="login__form">

                    <div className="login__imgform2">
                        <h3 className="login__emyto mt-15">Register</h3>
                        <Player
                            className="home__lottie"
                            autoplay
                            loop
                            src="../assets/gifts/36021-staking-on-ethereum.json"
                        >
                        </Player>
                    </div>
                    <div className="login__log">

                        <h3 className="login__emyto">Register</h3>
                        <button type="button" className="login-with-google-btn" >
                            Continue with Google
                    </button>

                        <Button onClick={goToLogin} variant="contained" >
                            Login
                                </Button>


                        <div className="login__subline"></div>

                        <form>
                            <Box
                                className="login__formbox"
                                component="form"
                                sx={{
                                    width: 400,
                                    maxWidth: '100%'
                                }}
                                noValidate
                                autoComplete="off"
                            >

                                <TextField
                                    id="Nombre"
                                    label="Nombre"
                                    className="login__input"
                                    name="name"
                                    variant="filled"
                                    value={name}
                                    onChange={handleInputChange}
                                />
                                      <TextField
                                    id="Wallet"
                                    label="Wallet"
                                    className="login__input"
                                    name="wallet"
                                    variant="filled"
                                    value={wallet}
                                    onChange={handleInputChange}
                                />
                                <TextField
                                    id="Email"
                                    label="Email"
                                    className="login__input"
                                    name="email"
                                    variant="filled"
                                    value={email}
                                    onChange={handleInputChange}
                                />
                                <br></br>
                                <TextField

                                    id="Password"
                                    label="Password"
                                    name="password"
                                    type="password"
                                    className="login__input"
                                    value={password}
                                    variant="filled"

                                    onChange={handleInputChange}
                                />


                                <Button onClick={handleSubmit} variant="outlined" className="login__button">
                                    SignIn
                                </Button>

                            </Box>

                        </form>

                    </div>


                </div>
            </div>

        </div>
    )
}
